import * as React from "react";

export interface MoneyDisplayProps
{
	amount: number;
	className?: string;
}

export class MoneyDisplay extends React.Component<MoneyDisplayProps, any>
{
	render()
	{
		return <span className={this.props.className}>${this.formatMoney(this.props.amount)}</span>;
	}

	formatMoney(num: number, c = 2, d = ".", t = ",")
	{
		let n: any = num;
		const sign = n < 0 ? "-" : "";
		const fixed = n = Math.abs(+n || 0).toFixed(c);
		const wholeNumber: any = parseInt(fixed) + "";
		let j: any;
		j = (j = wholeNumber.length) > 3 ? j % 3 : 0;
		return sign +
			(j ? wholeNumber.substr(0, j) + t : "") +
			wholeNumber.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) +
			(c ? d + Math.abs(n - wholeNumber).toFixed(c).slice(2) : "");
	}
}


// WEBPACK FOOTER //
// ./src/components/common/MoneyDisplay.tsx